import axios from 'axios';
import getAppConfiguration from '../appConfiguration';
import {
	publicRequestInterceptor,
	commonErrorInterceptor,
	addAuthRequestResponseInterceptor
} from "./authHelper";

const appConfig = getAppConfiguration();
const {
	hotelApiBaseUrl,
	hotelApiVersion,
	coreApiBaseUrl,
	coreApiVersion,
	availabilityApiBaseUrl,
	availabilityApiVersion,
} = appConfig;

const gateWayUrl = window.location.origin + '/gateway/api';

export const laravelHttpClient = axios.create();
laravelHttpClient.defaults.baseURL = gateWayUrl;
laravelHttpClient.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
laravelHttpClient.defaults.withCredentials = true;
addAuthRequestResponseInterceptor(laravelHttpClient)
//====================== Hotel Http Cleint

const hotelHttpClient = axios.create();

hotelHttpClient.defaults.baseURL = hotelApiBaseUrl + '/' + hotelApiVersion;
addAuthRequestResponseInterceptor(hotelHttpClient)

export const coreHttpClient = axios.create();
coreHttpClient.defaults.baseURL = coreApiBaseUrl + '/' + coreApiVersion;
addAuthRequestResponseInterceptor(coreHttpClient)

// client for availability
export const availabilityHttpClient = axios.create();
availabilityHttpClient.defaults.baseURL = availabilityApiBaseUrl + '/' + availabilityApiVersion;
addAuthRequestResponseInterceptor(availabilityHttpClient)
// ------------- Client for PUBLIC route of hotel service -------------  //

export const publicHotelHttpClient = axios.create();

publicHotelHttpClient.defaults.baseURL = hotelApiBaseUrl + '/' + 'public';

// ------------- Client for PUBLIC route of Core service -------------  //

export const publicCoreHttpClient = axios.create();
publicCoreHttpClient.defaults.baseURL = coreApiBaseUrl + '/' + 'public';
publicCoreHttpClient.interceptors.request.use(
	publicRequestInterceptor,
	commonErrorInterceptor
);

export const publicAvailabilityHttpClient = axios.create();
publicAvailabilityHttpClient.defaults.baseURL = availabilityApiBaseUrl + '/' + 'public';
publicAvailabilityHttpClient.interceptors.request.use(
	publicRequestInterceptor,
	commonErrorInterceptor
);

export default hotelHttpClient